import { render, staticRenderFns } from "./WashRequestDeliveryBoxChange.vue?vue&type=template&id=196dc786&scoped=true"
import script from "./WashRequestDeliveryBoxChange.vue?vue&type=script&lang=js"
export * from "./WashRequestDeliveryBoxChange.vue?vue&type=script&lang=js"
import style0 from "./WashRequestDeliveryBoxChange.vue?vue&type=style&index=0&id=196dc786&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "196dc786",
  null
  
)

export default component.exports